<template>
  <div class="options-pick-answer">
    <QuizOption
      v-for="(option, index) in slideOptions"
      :key="option.id"
      :index="index"
      :option="option"
      :class="{
        'correct': option.correct,
        'incorrect': !option.correct,
        'multiple': multipleChoice,
        'checked': answer.includes(option.id),
        'massive': isMassiveOptions,
      }"
    />
  </div>
</template>

<script>
import QuizOption from './QuizOption.vue'

export default {
  components: {
    QuizOption,
  },
  props: {
    quizAnswer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    answer() {
      return this.quizAnswer && this.quizAnswer.vote
    },
    slideOptions() {
      return this.quizAnswer
        && this.quizAnswer.Slide
        && this.quizAnswer.Slide.SlideOptions
    },
    multipleChoice() {
      return this.quizAnswer
        && this.quizAnswer.Slide
        && this.quizAnswer.Slide.multipleChoice
    },
    isMassiveOptions() {
      return this.slideOptions.length > 9
    },
  },
}
</script>

<style lang="scss" scoped>
.options-pick-answer {
  display: grid;
  row-gap: 8px;
}
</style>
